import { render, staticRenderFns } from "./LPassRuleList.vue?vue&type=template&id=45b27e50&scoped=true"
import script from "./LPassRuleList.vue?vue&type=script&lang=js"
export * from "./LPassRuleList.vue?vue&type=script&lang=js"
import style0 from "./LPassRuleList.vue?vue&type=style&index=0&id=45b27e50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b27e50",
  null
  
)

export default component.exports